import axios from "axios";

axios.interceptors.response.use( response => response.data ); // use "data" always for every resp